import { SidebarItem } from '@shared/sidebaritem';

export const sidebarItems: SidebarItem[] = [
	{
		label: 'FeatureFlagsAdmin',
		icon: 'acies_feature_flags',
		path: 'setup/featureflagsadmin',
		overlay: false,
		children: [],
		parents: ['Setup'],
		permission: 'iam:FlagsPut',
		forceTranslateKey: 'setup.sidebar.featureflagsadmin',
	},
	{
		label: 'CrossAccountOneMonitoring',
		icon: 'acies_sync',
		path: 'setup/cross-account-one-monitoring',
		overlay: false,
		children: [],
		parents: ['Setup'],
		permission: 'one:MonitoringOverview',
		topLevelPermission: true,
		forceTranslateKey: 'setup.cross-account-one-monitoring.sidebar.title',
	},
];
